export const detectMediaTypeFromMime = (mime = "") => {
  const lower = String(mime).toLowerCase();
  if (lower.startsWith("image/")) return "images";
  if (lower.startsWith("video/")) return "videos";
  if (lower.startsWith("audio/")) return "audio";
  return "documents";
};

/** @returns {"image"|"video"|"audio"|"document"} */
export const resolveTaskFileKind = (file) => {
  const mime = String(file?.type || file?.mimetype || "").toLowerCase();
  const mediaType = String(file?.mediaType || detectMediaTypeFromMime(mime)).toLowerCase();
  if (mediaType === "images" || mime.startsWith("image/")) return "image";
  if (mediaType === "videos" || mime.startsWith("video/")) return "video";
  if (mediaType === "audio" || mime.startsWith("audio/")) return "audio";
  return "document";
};

const TASK_FILE_KIND_LABELS = {
  image: "Image",
  video: "Video",
  audio: "Audio",
  document: "Document",
};

export const getTaskFileKindLabel = (kind) => TASK_FILE_KIND_LABELS[kind] || "File";
